module.exports = __webpack_public_path__ + "static/media/header-logo.837362b9.png";